import Moment from "moment";
import Calendar from "./calendar.model";
import CalendarData from "./calendar-data.model";

export default class WeekCalendar extends Calendar {

    constructor(calendar) {
        super(calendar);

        this.withSunday = calendar && calendar.withSunday || false;
        this._firstHour = calendar && calendar.firstHour || 0;
        this._lastHour = calendar && calendar.lastHour || 23;

        this.init();
    }

    init() {
        this.cols = [];
        this.rows = [];

        let date = Moment(this.date).startOf('week');
        let lastDay = this.withSunday ? 7 : 6;

        for (let d = 1; d <= lastDay; ++d) {
            this.cols.push(new CalendarData({
                date: Moment(date).day(d),
                timeUnit: 'date'
            }));
        }

        for (let h = this.firstHour; h <= this.lastHour; ++h) {
            this.rows.push(new CalendarData({
                date: Moment(date).hour(h),
                timeUnit: 'hour'
            }));
        }

        super.onInitComplete();
    }

    set withSunday(withSunday) {
        let update = this._withSunday != withSunday;
        if (update) {
            this._withSunday = withSunday;
            this.init();
        }
    }

    get withSunday() {
        return this._withSunday;
    }

    set firstHour(hour) {
        let update = this._firstHour != hour;
        if (update) {
            this._firstHour = hour;
            this.init();
        }
    }

    get firstHour() {
        return this._firstHour;
    }

    set lastHour(hour) {
        let update = this._lastHour != hour;
        if (update) {
            this._lastHour = hour;
            this.init();
        }
    }

    get lastHour() {
        return this._lastHour;
    }

    onDateUpdated(oldDate) {
        let update = this.date.year() != oldDate.year()
            || this.date.week() != oldDate.week();

        if (update) {
            this.cols.forEach(col => {
                col.date = Moment(this.date).startOf('week').isoWeekday(col.date.isoWeekday());
            });

            this.rows.forEach(row => {
                row.date = Moment(this.date).startOf('day').hour(row.date.hour());
            });
        }
    }

    formatColTitle(col) {
        return Moment(col.date).format('dd');
    }

    formatRowTitle(row) {
        return Moment(row.date).startOf('hour').format('HH:mm');
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/components/calendar/model/week-calendar.model.js